var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRoomsSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#ECFFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.59 12.58L15 19.17L11.41 15.59L10 17L15 22L23 14L21.59 12.58ZM17 7C11.48 7 7 11.48 7 17C7 22.52 11.48 27 17 27C22.52 27 27 22.52 27 17C27 11.48 22.52 7 17 7ZM17 25C12.58 25 9 21.42 9 17C9 12.58 12.58 9 17 9C21.42 9 25 12.58 25 17C25 21.42 21.42 25 17 25Z",
    fill: "#7CB966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRoomsSold);
export default __webpack_public_path__ + "static/media/Total_Rooms_Sold.ca1ca59e9079dcf56cb25f81791ab7b8.svg";
export { ForwardRef as ReactComponent };